import { Flex, Icon } from "@chakra-ui/react";

const PulseIcon = ({ icon, size = "32px", color = "p" }) => {
  return (
    <Flex
      borderRadius="100%"
      justify="center"
      align="center"
      w={size}
      h={size}
      bg={color + ".100"}
      border="4px solid"
      borderColor={color + ".50"}
    >
      <Icon as={icon} color={color + ".700"} boxSize={`calc(${size} * .50)`} />
    </Flex>
  );
};

export default PulseIcon;
